import React from 'react';
import { FileText, Award, Shield } from 'lucide-react';
export function Insurance() {
  const cards = [{
    title: 'Insurance Claim Help',
    copy: 'Get help with the quote, claim details and scheduling process.',
    icon: <FileText className="w-6 h-6 text-brand-blue" data-id="element-264" />
  }, {
    title: 'OEM & OEE Glass Options',
    copy: 'Ask about available glass options based on your vehicle, insurance, preference and budget.',
    icon: <Award className="w-6 h-6 text-brand-blue" data-id="element-265" />
  }, {
    title: 'Lifetime Workmanship Warranty',
    copy: 'Professional installation backed by a warranty on vehicle glass workmanship.',
    icon: <Shield className="w-6 h-6 text-brand-blue" data-id="element-266" />
  }];
  return <section className="py-16 lg:py-24 bg-navy-900 text-white" data-id="element-267">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-268">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-269">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-270">
            Insurance Help, Quality Glass & Warranty Protection
          </h2>
          <p className="text-lg text-slate-300" data-id="element-271">
            Kosin's Glass provides free auto glass quotes and can help
            coordinate with most insurance companies. The team installs quality
            glass that meets or exceeds OEM standards and backs auto glass
            workmanship with a lifetime vehicle glass workmanship warranty.
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-12 -mt-6 px-5 py-4 rounded-xl bg-navy-800/60 border border-navy-700 text-center" data-id="element-272">
          <p className="text-slate-200 text-sm md:text-base" data-id="element-273">
            Local drivers choose Kosin's Glass for insurance help, certified
            installation and a lifetime vehicle glass workmanship warranty.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-274">
          {cards.map((card, index) => <div key={index} className="bg-navy-800 rounded-2xl p-8 border border-navy-700 scroll-fade-up" style={{
          animationDelay: `${index * 0.08}s`
        }} data-id="element-275">
              <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-6 border border-navy-700 shadow-inner" data-id="element-276">
                {card.icon}
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-277">{card.title}</h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-278">{card.copy}</p>
            </div>)}
        </div>
      </div>
    </section>;
}